<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
    <!-- Contenet page started-->
    <div class="row">
      <div class="col-md-12">
        <!-- breadcrumb -->
        <div class="page-breadcrumb"><!-- new -->
          <ul class="page-breadcrumb__trail">
            <li><a>Reports</a></li>
            <li><a>Farm</a></li>
            <li><a>Culture Estimator</a></li>
          </ul>
          <div class="page-breadcrumb__icons">
            <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
          </div>
        </div>
        <div class="block">
          <div class="screen_heading_div">
            <span>Culture Estimator</span>
          </div>
          <div class="Reports_form_div">
            <form class="form-horizontal" id="myForm" role="form" [formGroup]="registerForm">
              <div class="reports-form-container" (clickOutside)="isDropdownOpen = false">
               
                <mat-form-field appearance="outline" class="w-100 custom-select" *ngIf="loginBusinessCategory != 'Farm'">
              <mat-label>Business Name</mat-label>
              <!-- search box powered by mat‑autocomplete -->
              <input matInput type="text" id="businessname" autocomplete="off" formControlName="businessfield"
                     placeholder="Search business" (keyup)="filterBusinesses()"
                     (click)="isDropdownOpen = true" (focus)="filteredOptions = businesses"
                     [matAutocomplete]="businessAuto"/>
              <mat-autocomplete #businessAuto="matAutocomplete" (optionSelected)="selectOption($event.option.value)">
                <mat-option *ngFor="let option of filteredOptions" [value]="option">
                  {{ option.businessName }}
                </mat-option>
              </mat-autocomplete>
              <mat-hint *ngIf="f.businessfield.invalid"><i>Select business</i></mat-hint>
              <mat-hint *ngIf="f.businessfield.valid"><i>Business selected</i></mat-hint>
              <mat-error *ngIf="(formSubmitted || f.businessfield.touched || f.businessfield.dirty) && f.businessfield.errors">
                <i *ngIf="f.businessfield.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Farm Site</mat-label>
                <mat-select id="location" formControlName="locationField" name="location" (click)="isDropdownOpen = false"
                            [(ngModel)]="farmsiteModel.id" (selectionChange)="getSectionsByFarmSiteID(farmsiteModel.id)">
                  <mat-option value="undefined" disabled>Select Farm site</mat-option>
                  <mat-option *ngFor="let farmsite of farmsites" [value]="farmsite.id">
                    {{ (farmsite?.farmNameAtLocation) }}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="f.locationField.invalid"><i>Select farm site</i></mat-hint>
                <mat-hint *ngIf="f.locationField.valid"><i>Farm site selected</i></mat-hint>
                <mat-error *ngIf="(formSubmitted || f.locationField.touched || f.locationField.dirty) && f.locationField.errors">
                  <i *ngIf="f.locationField.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>

                <!--Production Unit Field-->
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Section</mat-label>
                  <mat-select id="sections" formControlName="sectionField" name="section" (click)="isDropdownOpen = false"
                              [(ngModel)]="sectionModel.id">
                    <mat-option value="undefined" disabled>Select section</mat-option>
                    <mat-option *ngFor="let section of sections" [value]="section.id">
                      {{ (section?.section_name) }}
                    </mat-option>
                  </mat-select>
                  <mat-hint *ngIf="f.sectionField.invalid"><i>Select section</i></mat-hint>
                  <mat-hint *ngIf="f.sectionField.valid"><i>Section selected</i></mat-hint>
                  <mat-error *ngIf="(formSubmitted || f.sectionField.touched || f.sectionField.dirty) && f.sectionField.errors">
                    <i *ngIf="f.sectionField.hasError('required')">Required.</i>
                  </mat-error>
                </mat-form-field>
              </div>
            </form>
            <div class="buttons-div reports_search_div">
              <div class="transactions-button-container" (click)="onSubmit()">
                <button class="transaction-submit-button" [disabled]="submitButtonDisabled">
                  <span class="icon"><img src="../../../../../../../assets/images/New_Icons/search-icon.svg"></span>
                  <span class="text">Search</span>
                </button>
              </div>
            </div>
          </div>
          <div *ngIf="enableDisableDataLoader">
            <div class="adjust loader-container">
              <div class="loader2"></div>
            </div>
          </div>
          <div class="reports_block" *ngIf="dupCultureEstimatorsData && dupCultureEstimatorsData.Data && dupCultureEstimatorsData.Data.length > 0">
            <div class="actions-container">
              <div class="search-div">

              </div>
              <div class="action-btns">

              </div>
              <div class="action-icons" *ngIf="cultureEstimatorsData && cultureEstimatorsData.Data && cultureEstimatorsData.Data.length > 0">
                <img src="../../../../assets/images/New_Icons/excel-download-icon.svg" title="Excel downlaod" (click)="exportExcel()">
                <img src="../../../../assets/images/New_Icons/expand-icon.svg" title="Zoom in" (click)="openFullScreen()">
              </div>
            </div>
            <div class="table-responsive" id="zoomView" *ngIf="cultureEstimatorsData && cultureEstimatorsData.Data && cultureEstimatorsData.Data.length > 0">
              <table class="table table-striped table-bordered table-hover">
                <thead>
                <tr>
                  <th></th>
                  <th colspan="2" class="text-center">Tank Details</th>
                  <th colspan="10" class="text-center">Current Growth and Cost of Production</th>
                  <th colspan="10" class="text-center">Estimated Growth and Cost of Production</th>
                </tr>
                <tr>
                  <th>S.No</th>
                  <th>Tank Name</th>
                  <th>Stocking Count</th>
                  <th>DOC</th>
                  <th>Cumulative(Kgs)</th>
                  <th>DTF(Kgs)</th>
                  <th>ABW(gms)</th>
                  <th>Count</th>
                  <th>Animals</th>
                  <th>Biomass(Kgs)</th>
                  <th>Survival(%)</th>
                  <th>FCR</th>
                  <th>COP(₹)</th>
                  <th>DOC</th>
                  <th>Cumulative(Kgs)</th>
                  <th>DTF(Kgs)</th>
                  <th>ABW(gms)</th>
                  <th>Count</th>
                  <th>Animals</th>
                  <th>Biomass(Kgs)</th>
                  <th>Survival(%)</th>
                  <th>FCR</th>
                  <th>COP(₹)</th>
                </tr>
                </thead>
                <tbody>
                <tr
                  *ngFor="let list of cultureEstimatorsData.Data| paginate: { itemsPerPage: noOfItemsPerPage, currentPage: currentPageNumber }; let i = index">
                  <td>{{list.index + 1}}</td>
                  <td>{{list.pondname}}</td>
                  <td class="text-right">{{list.Stocking_count}}</td>
                  <td class="text-right">{{list.curr_DOC}}</td>
                  <td class="text-right">{{list.curr_CF_Kgs}}</td>
                  <td class="text-right">{{list.curr_DTF_Kgs}}</td>
                  <td class="text-right">{{list.Curr_ABW_grms}}</td>
                  <td class="text-right">{{list.Curr_count}}</td>
                  <td class="text-right">{{list.Prst_Animals}}</td>
                  <td class="text-right">{{list.Curr_Biomass_Kgs}}</td>
                  <td class="text-right">{{list.Curr_Survival}}</td>
                  <td class="text-right">{{list.Curr_FCR}}</td>
                  <td class="text-right">{{list.Curr_COP}}</td>
                  <td class="text-right">{{list.Est_DOC}}</td>
                  <td class="text-right">{{list.Est_CF_Kgs}}</td>
                  <td class="text-right">{{list.Est_DTF_Kgs}}</td>
                  <td class="text-right">{{list.Est_ABW_grms}}</td>
                  <td class="text-right">{{list.Est_Count}}</td>
                  <td class="text-right">{{list.Est_Animals}}</td>
                  <td class="text-right">{{list.Est_Biomass_Kgs}}</td>
                  <td class="text-right">{{list.Est_Survival}}</td>
                  <td class="text-right">{{list.Est_FCR}}</td>
                  <td class="text-right">{{list.Est_COP}}</td>
                </tr>
                <tr>
                  <td colspan="23">Section Aggregation Count</td>
                </tr>
                <tr>
                  <td>{{cultureEstimatorsData.Data.length}}</td>
                  <td></td>
                  <td class="text-right">{{cultureEstimatorsData.Aggregated_Data.Stocking_count}}</td>
                  <td class="text-right">{{cultureEstimatorsData.Aggregated_Data.curr_DOC}}</td>
                  <td class="text-right">{{cultureEstimatorsData.Aggregated_Data.curr_CF_Kgs}}</td>
                  <td class="text-right">{{cultureEstimatorsData.Aggregated_Data.curr_DTF_Kgs}}</td>
                  <td class="text-right">{{cultureEstimatorsData.Aggregated_Data.Curr_ABW_grms}}</td>
                  <td class="text-right">{{cultureEstimatorsData.Aggregated_Data.Curr_count}}</td>
                  <td class="text-right">{{cultureEstimatorsData.Aggregated_Data.Prst_Animals}}</td>
                  <td class="text-right">{{cultureEstimatorsData.Aggregated_Data.Curr_Biomass_Kgs}}</td>
                  <td class="text-right">{{cultureEstimatorsData.Aggregated_Data.Curr_Survival}}</td>
                  <td class="text-right">{{cultureEstimatorsData.Aggregated_Data.Curr_FCR}}</td>
                  <td class="text-right">{{cultureEstimatorsData.Aggregated_Data.Curr_COP}}</td>
                  <td class="text-right">{{cultureEstimatorsData.Aggregated_Data.Est_DOC}}</td>
                  <td class="text-right">{{cultureEstimatorsData.Aggregated_Data.Est_CF_Kgs}}</td>
                  <td class="text-right">{{cultureEstimatorsData.Aggregated_Data.Est_DTF_Kgs}}</td>
                  <td class="text-right">{{cultureEstimatorsData.Aggregated_Data.Est_ABW_grms}}</td>
                  <td class="text-right">{{cultureEstimatorsData.Aggregated_Data.Est_Count}}</td>
                  <td class="text-right">{{cultureEstimatorsData.Aggregated_Data.Est_Animals}}</td>
                  <td class="text-right">{{cultureEstimatorsData.Aggregated_Data.Est_Biomass_Kgs}}</td>
                  <td class="text-right">{{cultureEstimatorsData.Aggregated_Data.Est_Survival}}</td>
                  <td class="text-right">{{cultureEstimatorsData.Aggregated_Data.Est_FCR}}</td>
                  <td class="text-right">{{cultureEstimatorsData.Aggregated_Data.Est_COP}}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div *ngIf="cultureEstimatorsData && cultureEstimatorsData.Data && cultureEstimatorsData.Data.length <= 0" class="noDataFoundMessage">
              Data Not Found
            </div>
          </div>
          <div class="reports_block" *ngIf="dupCultureEstimatorsData && dupCultureEstimatorsData.Data && dupCultureEstimatorsData.Data.length <= 0 && isSubmitClicked">
            <div class="noDataFoundMessage">Data Not Available</div>
          </div>
        </div>
      </div>
    </div>
  </div>
